var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'transition m-1 min-h-12 min-w-12 rounded flex items-center justify-center',
    _vm.colorClass,
    _vm.roundedClass
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }